export interface IFbCollapseState {
  [fieldId: string]: boolean;
}

export interface IFbUiPreferences {
  sidebarWidth: number;
  outlineVisible: boolean;
  builderVersion: 'v1' | 'v2';
}

export const FB_V2_DEFAULTS: IFbUiPreferences = {
  sidebarWidth: 30,
  outlineVisible: false,
  builderVersion: 'v2',
};

export const FB_V2_STORAGE_KEY = 'form-builder-v2-preferences';
export const FB_V2_COLLAPSE_KEY = 'form-builder-v2-collapse';

export const FB_V2_SIDEBAR_MIN = 25;
export const FB_V2_SIDEBAR_MAX = 50;

export type FbBuilderMode = 'builder' | 'preview';
